









































































import Vue from "vue";
import LabelHorizontal from "@/components/travel_planning/LabelHorizontal.vue";
import LabelVertical from "@/components/travel_planning/LabelVertical.vue";
import ApiService from "@/services/ApiService";
// import { sign } from "crypto";
export default Vue.extend({
  components: {
    // DigitalTransform,
    // SingleBlock,
    LabelHorizontal,
    LabelVertical,
  },
  props: ["options"],
  watch: {
    options: function (newVal, oldVal) {
      this.getData();
    },
  },
  data() {
    return {
      signupsData: {
        dimensions: {
          name: "Month",
          data: [],
        },
        measures: [
          {
            name: "Posts",
            data: [],
          },
        ],
      },
      usersPostsData: {
        dimensions: {
          name: "Month",
          data: [],
        },
        measures: [
          {
            name: "Parents",
            data: [],
          },
          {
            name: "School",
            data: [],
          },
          {
            name: "Council",
            data: [],
          },
          {
            name: "Admin",
            data: [],
          },
        ],
      },
      usersContentData: {
        dimensions: {
          name: "Month",
          data: [],
        },
        measures: [
          {
            name: "Content",
            data: [],
          },
        ],
      },
      activeData: {
        dimensions: {
          name: "month",
          data: [],
        },
        measures: [
          {
            name: "Active",
            data: [],
          },
        ],
      },
      postsSettings: {
        stack: {
          sum: ["Parents", "School", "Council", "Admin"],
        },
      },
      theme: {
        color: [
          "#ff0092",
          "#009944",
          "#21acf5",
          "#5B00AF",
          "#c4ebad",
          "#96dee8",
        ],
      },
      totalSchools: 1,
      loading: false,
    };
  },
  methods: {
    getData() {
      this.loading = true;
      ApiService.generalApi
        .getEngagementStats(this.options)
        .then((resp) => {
          const data = resp.data.stats;
          this.totalSchools = resp.data.schoolCount;
          this.formatData(data, resp.data.stackedStats);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatData(data, stackedData) {
      const monthLabels = {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec",
      };
      const signupsData = {
          dimensions: { name: "month", data: [] },
          measures: [{ name: "Signups", data: [] }],
        },
        activeData = {
          dimensions: { name: "month", data: [] },
          measures: [{ name: "Active", data: [] }],
        },
        usersContentData = {
          dimensions: { name: "month", data: [] },
          measures: [{ name: "Content", data: [] }],
        },
        usersPostsData = {
          dimensions: { name: "month", data: [] },
          measures: [
            { name: "Parents", data: [] },
            { name: "School", data: [] },
            { name: "Council", data: [] },
            { name: "Admin", data: [] },
          ],
        };

      let _activeUsers;
      for (let index = 0; index < data.length; index++) {
        const singleMonth = data[index];
        let monthLabel = monthLabels[singleMonth.month];
        if (index == 12 || (data.length < 12 && index == data.length - 1)) {
          monthLabel = "Cur";
        }

        signupsData.dimensions.data.push(monthLabel);
        activeData.dimensions.data.push(monthLabel);
        usersContentData.dimensions.data.push(monthLabel);
        usersPostsData.dimensions.data.push(monthLabel);

        signupsData.measures[0].data.push(
          (singleMonth.students_perc / this.totalSchools).toFixed(2)
        );

        _activeUsers = (
          singleMonth.active_users_90days / this.totalSchools
        ).toFixed(2);

        activeData.measures[0].data.push(
          _activeUsers > 100 ? "100.00" : _activeUsers
        );
        usersContentData.measures[0].data.push(
          (singleMonth.users_created_content / this.totalSchools).toFixed(2)
        );
      }

      // let i = 0;
      for (const key in stackedData) {
        usersPostsData.measures[0].data.push(stackedData[key].new_notices[0]);
        usersPostsData.measures[1].data.push(stackedData[key].new_notices[1]);
        usersPostsData.measures[2].data.push(stackedData[key].new_notices[2]);
        usersPostsData.measures[3].data.push(stackedData[key].new_notices[3]);
        // i++;
      }

      this.signupsData = signupsData;
      this.activeData = activeData;
      this.usersContentData = usersContentData;
      this.usersPostsData = usersPostsData;
    },
  },
  computed: {},
  mounted() {
    this.getData();
  },
});
